import React from "react";
import { ModalBody } from "reactstrap";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import FieldInput from "../../../CustomComponents/FieldInput";
import CloudStorage from "../../../../CloudStorage/CloudStorage";

export default function ModelDate({
  lastdate,
  setModallast_date,
  hitApi,
  handleDateInputTitle,
}) {
  const getTodayDate = () => {
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, "0");
    const dd = String(today.getDate()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`;
  };

  const validationSchema = Yup.object({
    lastdate: Yup.string().required("Please select a date"),
  });

  return (
    <>
      {/* Close button */}
      <button
        onClick={() => setModallast_date((state) => !state)}
        className="btn close-button"
      >
        <img
          src={`${CloudStorage.cloudurl}/Assets/Images/common/close-icon.svg`}
          alt="close"
        />
      </button>

      <Formik
        initialValues={{ lastdate: lastdate || "" }}
        validationSchema={validationSchema}
        enableReinitialize
        onSubmit={(values, { setSubmitting }) => {
          console.log("Submitted values:", values); // ✅ log form values
          setSubmitting(true);

          // Update external state and trigger API
          handleDateInputTitle({ target: { value: values.lastdate } });

          // Close modal
          setModallast_date(false);
          setSubmitting(false);
          hitApi();
        }}
      >
        {({ values, handleChange, handleSubmit, isSubmitting }) => (
          <Form onSubmit={handleSubmit}>
            <ModalBody>
              <h4>Edit Last Date</h4>

              <div className="form-group">
                <FieldInput
                  title="Enter Last Date"
                  name="lastdate"
                  placeholder="Enter Last Date"
                  type="date"
                  min={getTodayDate()}
                  value={values.lastdate}
                  onChange={(e) => {
                    handleChange(e);
                    handleDateInputTitle(e); // also update external state
                  }}
                />
              </div>
            </ModalBody>

            <div className="modal-footer mt-3">
              <button
                type="submit"
                className="btn"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Saving..." : "Save"}
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </>
  );
}
